module.exports = __webpack_public_path__ + "img/keima.fa49f656.png";